export default {
  data() {
    return {
      touched: {},
      touchedWatcherActivated: true,
      unwatchers: []
    }
  },
  methods: {
    validateAll() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll()
          .then(isValid => {
            if (isValid) {
              resolve()
            } else {
              const errors = this.errors.collect()
              reject(errors)
            }
          })
      })
    },
    errorsMessage(char=',') {
      const msg = ''
      const allErrors = this.errors.all()

      return allErrors.join(char)
    },
    watchTouched(objectProperties) {
      for (let object in objectProperties) {
        if(!objectProperties.hasOwnProperty(object)) {
          continue
        }

        const properties = objectProperties[object]

        const unwatchers = properties.map((prop) => {
          const propKey = `${object}.${prop}`
          let unwatch
          unwatch = this.$watch(propKey, () => {
            if(!this.touchedWatcherActivated) {
              return
            }
            this.touched[prop] = true
            unwatch()
          })
          return unwatch
        })

        this.unwatchers = this.unwatchers.concat(unwatchers)
      }
    },
    
    unwatchTouched() {

      for(const unwatcher of this.unwatchers) {
        unwatcher()
      }

      this.unwatchers = []
      this.touched = {}
    },

    validField(field){
      if(this.touched[field] && !this.errors.has(field)){
        return true
      } else if (this.errors.has(field)){
        return false
      }
      return null
    },
    validationClass(field, defaultClasses){
      const classes = [
      { ['md-valid']: !this.errors.has(field) && this.touched[field] },
      { ['md-error']: this.errors.has(field) }
      ]

      if (defaultClasses) {
        classes.push({[defaultClasses]: true})
      }

      return classes
    }
  }
}



// WEBPACK FOOTER //
// ./src/globalMixins/validationMixin.js